import { Kind, TSchema, SchemaOptions, TypeRegistry } from '@sinclair/typebox';

TypeRegistry.Set<TUnionEnum>('UnionEnum', (schema, value) => {
  return (typeof value === 'string' || typeof value === 'number') && schema.enum.includes(value as never);
});
export type TUnionValue = string | number;

export interface TUnionEnum<T extends TUnionValue[] = []> extends TSchema {
  [Kind]: 'UnionEnum';
  static: T[number];
  enum: T;
}
/**
 * Creates an OpenAPI 'enum' representation for a list of strings/numbers
 * Examples
 *   const roomType = UnionEnum(['kitchen', 'living-room', 'sleeping-room'])
 *   const roomNumber = UnionEnum([1000, 1001, 1002])
 *
 * @param values list of enum values
 * @param options typebox schema options
 * @returns an enumeration representation of the input values
 */
export function UnionEnum<T extends TUnionValue[]>(values: [...T], options: SchemaOptions = {}) {
  // eslint-disable-next-line no-nested-ternary
  const type = values.every(value => typeof value === 'string')
    ? { type: 'string' }
    : values.every(value => typeof value === 'number')
    ? { type: 'number' }
    : {}; // mixed string | number
  return { ...options, [Kind]: 'UnionEnum', ...type, enum: values } as TUnionEnum<T>;
}
